export default {"src":"/_next/static/media/getsmarter-logo.3fe23546.svg","height":55,"width":139,"blurWidth":0,"blurHeight":0};